module.exports = __webpack_public_path__ + "img/laboratorio2_9-16.a78da0a0.jpg";